jQuery(document).ready(function ($) {
  //################################################################//
  //######*****   dynamite module spacer
  //################################################################//
  function every1_spacer() {
    var css = '';
    $('.m-spacer').each(function (i, spacer) {
      var uid = $(spacer).data('id');
      var body_width = $('body').width();
      var height_on_mob = $(spacer).data('height-mobile');
      var height_on_tabs = $(spacer).data('height-tab');
      var height_on_tabs_portrait = $(spacer).data('height-tab-portrait');
      var height = $(spacer).data('height');

      if (height != '') {
        css += ' .m-spacer-' + uid + ' { height:' + height + 'px } ';
      }
      if (
        height_on_tabs != '' ||
        height_on_tabs == '0' ||
        height_on_tabs == 0
      ) {
        css +=
          ' @media (max-width: 1199px) { .m-spacer-' +
          uid +
          ' { height:' +
          height_on_tabs +
          'px } } ';
      }
      if (
        typeof height_on_tabs_portrait != 'undefined' &&
        (height_on_tabs_portrait != '' ||
          height_on_tabs_portrait == '0' ||
          height_on_tabs_portrait == 0)
      ) {
        css +=
          ' @media (max-width: 991px) { .m-spacer-' +
          uid +
          ' { height:' +
          height_on_tabs_portrait +
          'px } } ';
      }
      // if(typeof height_on_mob_landscape != 'undefined' && (height_on_mob_landscape != '' || height_on_mob_landscape == '0' || height_on_mob_landscape == 0))
      // {
      // 	css += ' @media (max-width: 767px) { .m-spacer-'+uid+' { height:'+height_on_mob_landscape+'px } } ';
      // }
      if (height_on_mob != '' || height_on_mob == '0' || height_on_mob == 0) {
        css +=
          ' @media (max-width: 767px) { .m-spacer-' +
          uid +
          ' { height:' +
          height_on_mob +
          'px } } ';
      }
    });
    if (css != '') {
      css = '<style>' + css + '</style>';
      $('head').append(css);
    }
  }
  return every1_spacer();
});
